import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchNotifications,
  fetchNotificationByUserId,
  deleteNotificatonById,
  fetchReadNotifications,
} from "../../store/features/notification/notificationSlice";
import { Button, Table, Spinner, Badge } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { toast } from "react-toastify";
import { BsPencilSquare, BsTrash } from "react-icons/bs";
import NotificationModal from "./components/modals/NotificationModal";
import PageTitle from "../../components/pageTitle";
import { IoMdNotifications } from "react-icons/io";
import NoDataFound from "../../components/NoDataFound";

function Notification() {
  const dispatch = useDispatch();
  const { notifications, pagination, loading } = useSelector(
    (state) => state.notifications
  );
  const { role } = useSelector((state) => state.auth);
  const [editingNotification, setEditingNotification] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const [currentPage, setCurrentPage] = useState(0);
  const limit = 10;

  useEffect(() => {
    if (role === "superadmin") {
      dispatch(fetchNotifications({ page: currentPage + 1, limit }));
    } else {
      dispatch(fetchNotificationByUserId({ page: currentPage + 1, limit }));
    }
    dispatch(fetchReadNotifications());
  }, [dispatch, role, currentPage]);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };

  const handleEdit = (notify) => {
    setEditingNotification(notify);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    try {
      await dispatch(deleteNotificatonById(id)).unwrap();
      toast.info("Notification deleted");
      setCurrentPage(0);
      if (role === "superadmin") {
        dispatch(fetchNotifications({ page: 1, limit }));
      } else {
        dispatch(fetchNotificationByUserId({ page: 1, limit }));
      }
    } catch {
      toast.error("Error deleting notification");
    }
  };

  return (
    <>
      <PageTitle
        setShowForm={setShowForm}
        pageTitle={"Notifications"}
        setEditing={setEditingNotification}
        actionName={role === "staff" ? "" : "Send Notifications"}
      />

      {loading ? (
        <Spinner animation="border" />
      ) : (
        <>
          {notifications && notifications.length > 0 ? (
            <div className="table-wrapper">
              <Table responsive>
                <thead>
                  <tr>
                    <th>From</th>
                    <th>To Assistant</th>
                    <th>To Manager</th>
                    <th>To Staff</th>
                    <th>To Auditor</th>
                    <th>Message</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {notifications.map((notify) => (
                    <tr key={notify._id}>
                      <td>{notify.userId?.name}</td>
                      <td>
                        {notify.assistantSuperAdminIds?.map((user) => (
                          <Badge bg="success" className="me-2">
                            {user.name}
                          </Badge>
                        ))}
                      </td>
                      <td>
                        {notify.managerIds?.map((user) => (
                          <Badge bg="success" className="me-2">
                            {user.name}
                          </Badge>
                        ))}
                      </td>

                      <td>
                        {notify.staffIds?.map((user) => (
                          <Badge bg="success" className="me-2">
                            {user.name}
                          </Badge>
                        ))}
                      </td>

                      <td>
                        {notify.auditorIds?.map((user) => (
                          <Badge bg="success" className="me-2">
                            {user.name}
                          </Badge>
                        ))}
                      </td>
                      <td>{notify.message}</td>
                      <td className="actions">
                        <Button
                          size="sm"
                          variant="danger"
                          onClick={() => handleDelete(notify._id)}
                        >
                          <BsTrash />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              {pagination?.totalPages > 1 && (
                <ReactPaginate
                  breakLabel="..."
                  nextLabel="Next >"
                  previousLabel="< Prev"
                  onPageChange={handlePageClick}
                  pageCount={pagination.totalPages}
                  forcePage={currentPage}
                  containerClassName="pagination"
                  activeClassName="active"
                  pageRangeDisplayed={3}
                  marginPagesDisplayed={1}
                />
              )}
            </div>
          ) : (
            <NoDataFound
              icon={<IoMdNotifications size={50} />}
              title="Notification not found"
              description="Try to Create Notification"
            />
          )}

          {showForm && (
            <NotificationModal
              showForm={showForm}
              setShowForm={setShowForm}
              editingNotification={editingNotification}
              setEditingNotification={setEditingNotification}
            />
          )}
        </>
      )}
    </>
  );
}

export default Notification;
